import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'config-nav',
  templateUrl: './config-nav.component.html'
})
export class ConfigNavComponent implements OnInit {

  labsAccess = false;
  constructor(private authService: AuthService) { }

  async ngOnInit() {
    this.labsAccess = await this.authService.getHasLabsAccess();
  }

}



// WEBPACK FOOTER //
// ./client/app/config/config-nav/config-nav.component.ts